export var USER_LOGGED_IN = 'user-store-logged-in';
export var USER_LOGGED_OUT = 'user-store-logged-out';